import { type AccessToken } from '@okta/okta-auth-js';
import axios, { type AxiosInstance, type AxiosRequestConfig } from 'axios';

import { ENV } from '../env';

import { oktaAuth } from './oktaInitialization';

/**
 * Get the default headers for the API client
 * @returns The default headers with authorization token
 */
export const getDefaultHeaders = async () => {
  const accessToken = (await oktaAuth.tokenManager.get('accessToken')) as AccessToken;
  const headers = () => ({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken.accessToken}`,
  });

  return { headers };
};

let apiClient: AxiosInstance;
const initializeApiClient = (config?: AxiosRequestConfig): void => {
  apiClient = axios.create({
    baseURL: `${ENV.BACKEND_API_DOMAIN}/v1`,
    timeout: 10000,
    ...config,
  });
};

/**
 * Initialize the API client with default configuration
 */
initializeApiClient();

/**
 * Configure the API client with a custom Axios instance
 * @param customClient - The custom Axios instance to use
 */
export const configureApiClient = (customClient: AxiosInstance): void => {
  apiClient = customClient;
};

/**
 * Reset the API client to the default instance
 */
export const resetApiClient = (): void => {
  initializeApiClient();
};

/**
 * Get the current API client instance
 * @returns The current Axios instance
 */
export const getApiClient = (): AxiosInstance => apiClient;
